import React, { useRef, useContext, useEffect, useState } from "react";
import "./template.scss";
import { QuestionsContextMemorySpace } from "../../../contexts/questions/questionsContext";
import { useLocation, Link } from "react-router-dom";
import dompurify from "dompurify";
import CommonLoader from "../../../components/common/loader";
import axios from "axios";

const PreviewTemplateComponent = () => {
  const [currentData, setCurrentData] = useState(null);
  const refBusqueda = useRef();
  const location = useLocation();
  const sanitizer = dompurify.sanitize;
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const slug = location.pathname.split("/").pop();
    axios
      .get(
        `${process.env.REACT_APP_STRAPI_QA}/categorias?_publicationState=preview&published_at_null=true&eliminado=false`
      )
      .then((response) => {
        const foundData = response.data.find((item) => item.slug === slug);

        if (foundData) {
          setCurrentData(foundData);
        }
      })
      .catch((error) => {
        // console.log("error", error);
      });

    setLoader(false);
  }, [location.pathname, loader]);

  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.slice(0, maxLength) + "...";
    }
    return text;
  };

  return (
    <section className=" " ref={refBusqueda}>
      {loader ? (
        <CommonLoader></CommonLoader>
      ) : (
        <div className="container container-padre" id="container-resultados">
          {/* TITULO */}
          <div className="row mb-3">
            <div className="col-lg-12">
              <h2 className="section_hb_title title-results">
                <b className="section_hb_title">{currentData?.titulo}</b>
              </h2>
            </div>
          </div>

          {/* LISTADO DE PREGUNTAS */}
          <div className="row">
            {currentData?.subCategorias.map((categoria) => (
              <div
                key={categoria.id}
                className="col-12 mb-4 preguntas-contenido"
              >
                <div className="breadcrumb-container">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to={`/micrositio`}>Central de Ayuda</Link>
                      </li>
                      <li
                        className="breadcrumb-item active-breadcrumb"
                        aria-current="page"
                      >
                        {currentData?.titulo}
                      </li>
                    </ol>
                  </nav>
                </div>
                <h4>{categoria.titulo}</h4>
                <div>
                  {/* <p className="contenido">{categoria.contenido}</p> */}
                  <p className="contenido">
                    <div
                      // className="innerHTML"
                      dangerouslySetInnerHTML={{
                        __html: sanitizer(
                          truncateText(categoria?.contenido, 483)
                        ),
                      }}
                    />
                    {/* {truncateText(categoria.contenido, 483)} */}
                    <Link to={`${categoria.id}`} className="ver-mas">
                      Ver más
                    </Link>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default PreviewTemplateComponent;
